import { typedQueryClient, useTypedQuery } from "hooks/useTypedQuery";
import { DealerLicenseQueryKeys } from "modules/DealerLicenseOverview/queryKeys";

import type { PaginatedInvoicesType } from "modules/DealerLicenseOverview/queryKeys";

export const usePaginatedInvoices = () => useTypedQuery({ queryKey: DealerLicenseQueryKeys.paginatedInvoices, initialData: { data: [] } }).data;
export const setPaginatedInvoices = (data: PaginatedInvoicesType) => typedQueryClient.setQueryData(DealerLicenseQueryKeys.paginatedInvoices, data);
export const getPaginatedInvoices = () => typedQueryClient.getQueryData(DealerLicenseQueryKeys.paginatedInvoices) || { data: [] };
